// @ts-strict-ignore
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';

export class CentreArticleLocationVO extends ArticleLocationVO {
  public rotationAngle: number;
  public offsetReferencesMiddlePoint: boolean = false;

  public constructor() {
    super();
  }
}
